// "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function convertArrayOfObjectsToCSV<Type>(array: Type[]): string {
  let result: string;

  const columnDelimiter = ';';
  const lineDelimiter = '\n';
  type keysType = keyof (typeof array)[0];
  const keys = Object.keys(array[0] as {});

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach((key: string) => {
      if (ctr > 0) result += columnDelimiter;
      const a = key as keysType;
      result += item[a];

      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

export function downloadCSV<Type>(array: Type[], filename: string) {
  const link = document.createElement('a');
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', `${filename}.csv`);
  link.click();
}
